import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_agent_vc_squad_qr_code_RowClass} from "../../../../dbschema";

export class AgentVirtualContactSquadQrContainerModel extends BaseContainerModel {
  bl_alg_cc_agent_vc_squad_qr_code: bl_alg_cc_agent_vc_squad_qr_code_RowClass = new bl_alg_cc_agent_vc_squad_qr_code_RowClass();
}
